export const sustainableDevelopmentGoalsDescriptions = [
  "End poverty in all its forms everywhere",
  "Rethink how we grow, share and consume our food. We can provide nutritious food for all.",
  "Ensure healthy lives and promote well-being for all at all ages.",
  "Ensure that all girls and boys complete free, equitable and quality education.",
  "Achieve gender equality and empower all women and girls.",
  "Ensure access to water and sanitation for all.",
  "Ensure access to affordable, reliable, sustainable and modern energy.",
  "Promote inclusive and sustainable economic growth, employment and decent work for all.",
  "Build resilient infrastructure, promote sustainable industrialization and foster innovation.",
  "Reduce inequality within and among countries.",
  "Make cities inclusive, safe, resilient and sustainable.",
  "Ensure sustainable consumption and production patterns.",
  "Take urgent action to combat climate change and its impacts.",
  "Conserve and sustainably use the oceans, seas and marine resources.",
  "Sustainably manage forests, combat desertification, halt and reverse land degradation, halt biodiversity loss.",
  "Promote just, peaceful and inclusive societies.",
  "Revitalize the global partnership for sustainable development.",
];
